module.exports = function() {
  return new Worker(__webpack_public_path__ + "91b0b2398fa555b060b8.worker.js");
};